import { AgentAudienceKey, ColumnConfig } from '../model';

export const agentAudienceConfig: Record<AgentAudienceKey, ColumnConfig> = {
  checkBox: {
    name: '',
    field: 'checkbox',
    isCheckboxField: false,
  },
  sno: { name: 'S.No', field: 'component' },
  customer: { name: 'Customer', field: 'component' },
  customerCode: { name: 'Customer Code', field: 'component' },
  routes: { name: 'Routes', field: 'component' },
  segments: { name: 'Segments', field: 'component' },
  status: { name: 'Status', field: 'component' },
  // actions: { name: 'Actions', field: 'component' },
};
